import {
  GridRenderCellParams,
  GridRenderHeaderFilterProps,
} from '@mui/x-data-grid-pro';
import ArrCheckbox from '../../../../common/arr-checkbox/ArrCheckbox';
import FilterTextField from '../../../../common/arr-data-grid-pro/filter-components/text-field/FilterTextField';
import {t} from 'i18next';
import {Typography} from '@mui/material';
import {IPreviewDoc} from '../JobResults';

interface IColumn {
  rows: any[];
  handleErrorDocClicked: (props: IPreviewDoc) => void;
}
export const columns = ({rows, handleErrorDocClicked}: IColumn) => [
  {
    field: 'docID',
    headerName: '',
    filterable: false,
    sortable: false,
    cellClassName: 'typo-text subhead5_size',
    width: 160,
    renderHeader: () => (
      <Typography
        className="typo-text label2_size"
        tabIndex={0}
        role="columnheader"
        data-testid={`doc-error-panel-data-doc-id-header`}
      >
        {t('ai.review.jobErrorPanel.docId')}
      </Typography>
    ),

    renderCell: (params: GridRenderCellParams) => {
      if (params.row.isFilterRow) return null;

      const isClickable = !!params.row.docID;

      return (
        <Typography
          tabIndex={0}
          className={`typo-text subhead5_size ${isClickable ? 'docIdClickable' : 'docIdNonClickable'}`}
          onClick={(e) => {
            if (isClickable) {
              e.stopPropagation();
              handleErrorDocClicked({
                id: params.row.documentID,
                docId: params.row.docID,
              });
            }
          }}
          data-testid={`doc-error-panel-docId-${params.id}`}
        >
          {params.value}
        </Typography>
      );
    },
  },
  {
    field: 'errorMessage',
    headerName: `${t('ai.review.jobErrorPanel.errorMessage')}`,
    flex: 3,
    cellClassName: 'typo-text body3_size',
    sortable: false,
    filterable: true,
    renderHeader: () => (
      <Typography
        className="typo-text label2_size"
        tabIndex={0}
        role="columnheader"
        data-testid={`doc-error-panel-data-error-message-header`}
      >
        {t('ai.review.jobErrorPanel.errorMessage')}
      </Typography>
    ),
    renderCell: (params: GridRenderCellParams) => {
      return (
        <Typography
          className="cell-content typo-text body3_size"
          tabIndex={0}
          role="gridcell"
          data-testid={`doc-error-panel-data-err-message-${params.id}`}
        >
          {params.value}
        </Typography>
      );
    },
    renderHeaderFilter: (params: GridRenderHeaderFilterProps) => {
      return (
        <FilterTextField
          dataTestId={`errorMessage`}
          gridRenderHeaderFilterProps={params}
          placeholder={t('common.filter')}
          className="custom-filter"
        />
      );
    },
  },
];
